// Lib
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const postDensityConfig = {
    title: 'chart.tiktok.post_density',
    tooltip: 'chart.tiktok.tooltip_post_density',
    id: 'posts_density',
    tickFormatterTranslation: 'commons:days_short',
    tableColumnFormatterTranslation: 'commons:days',
    margin: {
        left: -40
    },
    name: {
        day: 'chart.tiktok.post_density_day',
        date_hour: 'chart.tiktok.post_density_time',
        value: 'chart.tiktok.post_density_value',
        avg: {
            daily: 'chart.tiktok.post_density_avg_daily',
            hourly: 'chart.tiktok.post_density_avg_hourly'
        }
    },
    legendTypes: {
        value: 'square',
        avg: 'line'
    },
    social: TIKTOK_BUSINESS,
    valueFormat: classicFormat,
    color: {
        value: 'blue',
        avg: 'gray'
    },
    tooltipTranslation: {
        token: 'chart.facebook.tooltip_postDensity_history',
        values: ['day', 'date_hour', 'value', 'percentage_evolution']
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart,
    defaultFilter: 'daily',
    defaultTableSorting: [],
    filters: {
        daily: {
            title: 'chart.facebook.post_density_daily',
            menu: 'chart.facebook.post_density_show_daily'
        },
        hourly: {
            title: 'chart.facebook.post_density_hourly',
            menu: 'chart.facebook.post_density_show_hourly'
        }
    },
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
